<script setup lang="ts">
import type { ComboboxContentEmits, ComboboxContentProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

import { cn } from '@/utils';
import { ComboboxContent, useForwardPropsEmits } from 'reka-ui';
import { computed } from 'vue';

const props = defineProps<
	ComboboxContentProps & {
		class?: HTMLAttributes['class'];
	}
>();

const emits = defineEmits<ComboboxContentEmits>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
	<ComboboxContent
		v-bind="forwarded"
		position="inline"
		:body-lock="false"
		:class="cn('max-h-[300px] overflow-y-auto overflow-x-hidden', props.class)"
	>
		<div role="presentation">
			<slot />
		</div>
	</ComboboxContent>
</template>
